import React from 'react'
import {Row, Col} from 'antd/lib/index'
import Calculator from '../Components/Calculator'

import './TemplatesPage.less'
import './CalculatorPage.less'

function CalculatorPage() {

    return (
        <div className='content-page calculator-page' >
            <Row gutter={{xl: 0, md: 16}} className='main-container'>
                <Row gutter={[{xl: 0}, {xl: 20}]} className='main-container'
                     style={{minHeight: '500px', flexWrap: 'nowrap'}}>
                    <Col flex='1 0'>
                        <Calculator calculator={'CPA'} />
                    </Col>
                </Row>
            </Row>
        </div>
    )
}

export default CalculatorPage
